import { AuthService } from '$services/auth/auth.service'
import { ConfirmService } from '$services/confirm.service'
import { IconsService } from '$services/icons/icons.service'
import { PostsService } from '$services/posts/posts.service'
import { ContactRole, CreatePostForm, FormState, HorseCategory, HorseDTO, HorseSex, PostStatus, UpdateContactForm, UpdateHorseForm, UpdatePostForm, User, UserDisplay, CreatePostFormWithoutPhotos } from '$types'
import { Component, OnInit } from '@angular/core'
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms'
import { MatSnackBar } from '@angular/material/snack-bar'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Observable } from 'rxjs'
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { concatMap, catchError, tap, finalize  } from 'rxjs/operators';
import { forkJoin, of, from, concat } from 'rxjs';
import { Message } from 'primeng/api';

@Component({
  selector: 'app-create-post-page',
  templateUrl: './create-post-page.component.html',
  styleUrls: ['./create-post-page.component.css']
})

export class CreatePostPageComponent implements OnInit {
  user: User | null
  form: FormGroup<any> = this.formBuilder.group({})
  formState: FormState = {
    finished: false,
    currentStep: -1,
    showPrev: false,
    showNext: false,
    showSaveDraft: false,
    steps: [],
  }
  data?: UpdatePostForm
  success_message: string
  failure_message: string
  adminMode: boolean
  adminPostUser?: UserDisplay
  adminPostUserSelected?: UserDisplay

  messages: Message[] = [];

  constructor(private readonly formBuilder: FormBuilder,
    private readonly postService: PostsService,
    private readonly authService: AuthService,
    private readonly confirmService: ConfirmService,
    private readonly translateService: TranslateService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private readonly iconsService: IconsService) {

    this.iconsService.registerIcon(['device-floppy'])
    this.iconsService.registerIcon(['check'])
    this.iconsService.registerIcon(['chevron-right'])
    this.iconsService.registerIcon(['chevron-left'])
    this.iconsService.registerIcon(['user-plus'])
    this.success_message = this.translateService.instant('success.save')
    this.failure_message = this.translateService.instant('errors.save')
    this.user = this.authService.user
    this.adminMode = this.userIsModerator(this.authService.user)
  }

  ngOnInit(): void {

    this.formState.finished = false
    this.formState.currentStep = -1
    this.formState.showNext = false
    this.formState.showSaveDraft = false
    this.formState.steps = []
  }

  registerForm($event: UpdatePostForm) {
    this.data = $event
  }

  publish() {

    if (this.adminMode) {
      this.askForIfPostIdFree()
        .subscribe((status) => this.sendCreatePostAdmin(status??false))
    }
    else {
      this.sendCreatePost()
    }
  }
  private askForIfPostIdFree(): Observable<any> {
    return this.confirmService.ConfirmDialog('Publier l\'annonce ?', 'Voulez vous publier l\'annonce pour ' + this.adminPostUserSelected?.displayNameString + ' ?')
  }

  private sendCreatePost(): void {
    const post = this.entityUpdate
    const { photos, ...newPost } = post;
    const photosFiles = this.form.get('horse_informations')!.get('horse_photos')!.value
    const isValidPhotos = Array.isArray(photosFiles._files) && photosFiles._files.every((photo: File) => {
      const isJpg = photo.type === 'image/jpeg';
      const isSizeValid = photo.size <= 5 * 1024 * 1024; // 5 Mo en octets
      return isJpg && isSizeValid;
    });
    if (!isValidPhotos && Array.isArray(photosFiles._files)) {
          this.messages = [{ severity: 'error', summary: 'Erreur', detail: 'Certaines photos ne sont pas valides. Veuillez varifier que les photos sont de type JPEG et de taille maximale de 5mo par photo.' }];
          console.error('Certaines photos ne sont pas valides. Veuillez varifier que les photos sont de type JPEG et de taille maximale de 5mo par photo.');
          return;
        }

        this.postService.create(newPost).subscribe(
           (response: any) => {
             const postId = response.id;
             if (Array.isArray(photosFiles._files)){
               this.uploadPhotos(postId, photosFiles).subscribe(
                 () => {
                   console.log('Toutes les photos ont été ajoutées avec succès');
                 },
                 error => {
                   console.error('Error adding photos', error);
                 }
               );
             } else {
              this.returnToPosts().complete();
             }
           },
           error => {
             console.error('Error creating post', error);
           }
         );
  }

  private sendCreateDraftPost(): void {
    const post = this.entityUpdate
    const { photos, ...newPost } = post;
    const photosFiles = this.form.get('horse_informations')!.get('horse_photos')!.value
    const isValidPhotos = Array.isArray(photosFiles._files) && photosFiles._files.every((photo: File) => {
      const isJpg = photo.type === 'image/jpeg';
      const isSizeValid = photo.size <= 5 * 1024 * 1024; // 5 Mo en octets
      return isJpg && isSizeValid;
    });
    if (!isValidPhotos && Array.isArray(photosFiles._files)) {
      this.messages = [{ severity: 'error', summary: 'Erreur', detail: 'Certaines photos ne sont pas valides. Veuillez varifier que les photos sont de type JPEG et de taille maximale de 5mo par photo.' }];
      console.error('Certaines photos ne sont pas valides. Veuillez varifier que les photos sont de type JPEG et de taille maximale de 5mo par photo.');
      return;
    }

    this.postService.createDraft(newPost).subscribe(
       (response: any) => {
         const postId = response.id;
         if (Array.isArray(photosFiles._files)){
           this.uploadPhotos(postId, photosFiles).subscribe(
             () => {
               console.log('Toutes les photos ont été ajoutées avec succès');
             },
             error => {
               console.error('Error adding photos', error);
             }
           );
         } else {
          this.returnToPosts().complete();
         }
       },
       error => {
         console.error('Error creating post', error);
       }
     );
  }


  private sendCreatePostAdmin(free: boolean): void {

    if (!this.adminPostUserSelected) {
      console.error('Aucun utilisateur sélectionné, création de l\'annonce impossible');
      return;
    }

    const adminPost = this.entityUpdate;
    adminPost.idClient = this.adminPostUserSelected.id; // assign selected user to post
    adminPost.mailConfirmation = true; // force mail notification

    const { photos, ...newAdminPost } = adminPost;
    const photosFiles = this.form.get('horse_informations')!.get('horse_photos')!.value;

    if (photosFiles && Array.isArray(photosFiles._files)) {
      const isValidPhotos = photosFiles._files.every((photo: File) => {
        const isJpg = photo.type === 'image/jpeg';
        const isSizeValid = photo.size <= 5 * 1024 * 1024; // 5 Mo en octets
        return isJpg && isSizeValid;
      });

      if (!isValidPhotos) {
        this.messages = [{ severity: 'error', summary: 'Erreur', detail: 'Certaines photos ne sont pas valides. Veuillez vérifier que les photos sont de type JPEG et de taille maximale de 5 Mo par photo.' }];
        console.error('Certaines photos ne sont pas valides. Veuillez vérifier que les photos sont de type JPEG et de taille maximale de 5 Mo par photo.');
        return;
      }
    }

    this.postService.createDraftAdmin(newAdminPost, free).subscribe(
      (response: any) => {
        const postId = response.id;
        if (Array.isArray(photosFiles._files)){
          this.uploadPhotos(postId, photosFiles).subscribe(
            () => {
              console.log('Toutes les photos ont été ajoutées avec succès');
            },
            error => {
              console.error('Erreur lors de l\'ajout des photos', error);
            }
          );
        } else {
          this.returnToPosts().complete();
        }
      },
      error => {
        console.error('Erreur lors de la création de l\'annonce', error);
      }
    );
  }

  private sendCreateDraftPostAdmin(free:boolean): void {

    if (!this.adminPostUserSelected) {
      console.error('Aucun utilisateur sélectionné, création de l\'annonce impossible');
      return;
    }

    const adminPost = this.entityUpdate;
    adminPost.idClient = this.adminPostUserSelected.id; // assign selected user to post
    adminPost.mailConfirmation = true; // force mail notification

    const { photos, ...newAdminPost } = adminPost;
    const photosFiles = this.form.get('horse_informations')!.get('horse_photos')!.value;

    if (photosFiles && Array.isArray(photosFiles._files)) {
      const isValidPhotos = photosFiles._files.every((photo: File) => {
        const isJpg = photo.type === 'image/jpeg';
        const isSizeValid = photo.size <= 5 * 1024 * 1024; // 5 Mo en octets
        return isJpg && isSizeValid;
      });

      if (!isValidPhotos) {
        this.messages = [{ severity: 'error', summary: 'Erreur', detail: 'Certaines photos ne sont pas valides. Veuillez vérifier que les photos sont de type JPEG et de taille maximale de 5 Mo par photo.' }];
        console.error('Certaines photos ne sont pas valides. Veuillez vérifier que les photos sont de type JPEG et de taille maximale de 5 Mo par photo.');
        return;
      }
    }

    this.postService.createDraftAdmin(newAdminPost, free).subscribe(
      (response: any) => {
        const postId = response.id;
        if (Array.isArray(photosFiles._files)){
          this.uploadPhotos(postId, photosFiles).subscribe(
            () => {
              console.log('Toutes les photos ont été ajoutées avec succès');
            },
            error => {
              console.error('Erreur lors de l\'ajout des photos', error);
            }
          );
        } else {
          this.returnToPosts().complete();
        }
      },
      error => {
        console.error('Erreur lors de la création de l\'annonce', error);
      }
    );
  }


  uploadPhotos(postId: string, photos: any): Observable<any> {
    const horsePhotos = photos?._files || [];
    const observables: Observable<any>[] = horsePhotos.map((photo: File) => {
      return this.postService.addPhotoToPost(postId, photo).pipe(
        catchError(error => {
          console.error('Error adding photo', error);
          return of(error);
        })
      );
    });

    return concat(...observables).pipe(
      finalize(() => {
        this.returnToPosts().complete();
      })
    );
  }



  private userIsModerator(user: User | null): boolean {
    return user?.moderator ?? false
  }
  private returnToPosts() {
    return {
      complete: () => {
        this.router.navigate(['/posts']);
      }
    };
  }

  saveDraft() {
    if (this.adminMode) {
      this.askForIfPostIdFree()
          .subscribe((status) => this.sendCreateDraftPostAdmin(status??false))
    }
    else {
      this.sendCreateDraftPost()
    }
  }

  prevStep(): void {
    this.formState.currentStep = (this.formState?.currentStep ?? 0) - 1
    this.formState.showNext = true
    if (this.formState.currentStep < 1) {
      this.formState.currentStep = 0
      this.formState.showPrev = false
    }
    if (this.formState.currentStep > this.formState.steps.length - 1) {
      this.formState.currentStep = this.formState.steps.length - 1
    }
    if (this.formState.currentStep == this.formState.steps.length - 1) {
      //this.formState.showNext = false
      this.formState.finished = true
    }
  }

  nextStep(): void {
    this.formState.currentStep = (this.formState?.currentStep ?? 0) + 1
    this.formState.showPrev = true
    if (this.formState.currentStep > this.formState.steps.length - 1) {
      this.formState.currentStep = this.formState.steps.length - 1
    }
    if (this.formState.currentStep == this.formState.steps.length - 1) {
      this.formState.showNext = false
      this.formState.finished = true
    }
  }
  private get entityUpdate(): CreatePostForm {
    if (this.form == null) {
      throw new Error("entityForm")
    }
    if ((!this.user)) {
      throw new Error("user")
    }
    if ((!this.form.valid)) {
      throw new Error("entityForm")
    }

    const sireControl = this.form.get('sire')!,
      horseControl = this.form.get('horse_informations')!,
      contactControl = this.form.get('contact_informations')!,
      documentsControl = this.form.get('documents')!


    return {
      idClient: this.user.id || 'x0',
      category: horseControl.get('category')!.value.toUpperCase() || HorseCategory.YEARLING,
      sellPrice: horseControl.get('sell_price')!.value,
      commentsEn: horseControl.get('comments_en')!.value,
      commentsFr: horseControl.get('comments_fr')!.value,
      toNegociate: horseControl.get('to_negociate')!.value,
      taxableVat: horseControl.get('taxable_vat')!.value,
      mailConfirmation: contactControl.get('mail_confirmation')!.value,
      status: PostStatus.WAITING_VALIDATION,
      photos: horseControl.get('horse_photos')!.value,
      certificateOfSale: documentsControl.get('certificate_of_sale')!.value,
      certificationOfThePerson: documentsControl.get('certification_of_the_person')!.value,
      extractKbis: documentsControl.get('extract_kbis')!.value,
      horseRegistration: documentsControl.get('horse_registration')!.value,
      contact: this.getContact(contactControl, documentsControl),
      horse: this.entityHorseUpdate(horseControl, sireControl.value)
    }
  }

  private getContact(contact: AbstractControl, documentsControl: AbstractControl): UpdateContactForm {
    return {
      firstName: contact.get('first_name')!.value,
      lastName: contact.get('last_name')!.value,
      role: documentsControl.get('role')!.value.toUpperCase() || ContactRole.UNIQUE_OWNER,
      landlinePhoneNumber: contact.get('landline_phone_number')!.value,
      mobilePhoneNumber: contact.get('mobile_phone_number')!.value,
      email: contact.get('email')!.value,
      isEnglish: contact.get('is_english')!.value,
    }
  }

  private entityHorseUpdate(horseForm: AbstractControl, sire: string): UpdateHorseForm {
    return {
      id: '',
      name: horseForm.get('horse_name')?.value,
      birthYear: horseForm.get('horse_year')?.value,
      sex: horseForm.get('horse_sex')?.value.toUpperCase() || HorseSex.MALE.toUpperCase(),
      raceRecord: horseForm.get('horse_record')?.value,
      totalEarn: horseForm.get('horse_total_earn')?.value,
      mother: horseForm.get('horse_mother')?.value,
      father: horseForm.get('horse_father')?.value,
      location: horseForm.get('horse_location')?.value,
      mailConfirmation: horseForm.get('mail_confirmation')?.value,
      sire: sire,
      photos: []
    }
  }
}
